import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  StyledSectionSelectorContainer,
  SectionSelectorTitle,
  SectionSelectorOptionsContainer,
  CheckboxWrapper,
} from './styled.sectionSkeleton';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonContainer } from './../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
export function SectionsSkeleton () {
  return (
    <>
      <StyledSectionSelectorContainer>
        <SectionSelectorTitle>
          <Skeleton width={34} />
        </SectionSelectorTitle>
        <SectionSelectorOptionsContainer>
          <CheckboxWrapper>
            <Skeleton height={20} width={20} />
            <Skeleton height={20} width={60} />
          </CheckboxWrapper>
          <CheckboxWrapper>
            <Skeleton height={20} width={20} />
            <Skeleton height={20} width={60} />
          </CheckboxWrapper>
          <CheckboxWrapper>
            <Skeleton height={20} width={20} />
            <Skeleton height={20} width={60} />
          </CheckboxWrapper>
        </SectionSelectorOptionsContainer>
      </StyledSectionSelectorContainer>
      <ButtonContainer>
        <ButtonBlockColumn>
          <Skeleton height={48} borderRadius={8} />
          <Skeleton height={48} borderRadius={8} />
          <Skeleton height={48} borderRadius={8} />
        </ButtonBlockColumn>
      </ButtonContainer>
    </>
  );
}
